import { t } from 'app/i18l'
import { useCompanyPreferences } from 'company/queries/list'
import { HomeItem } from 'home/types'
import { useUser } from 'users/queries/detail'

export function useDailyPayHomeItem(): HomeItem | undefined {
  const { data: user } = useUser()
  const { data: companyPreferences } = useCompanyPreferences()

  const dailyPayEnabled = companyPreferences?.dailyPayEnabled

  const isUserObserverOrAdmin =
    user?.role === 'admin' || user?.role === 'observer'

  if (!dailyPayEnabled || isUserObserverOrAdmin) {
    return undefined
  }

  return {
    title: t('myEarnings'),
    route: { name: 'DailyPay' },
    backgroundColor: '#FCEBE3',
    summary: {
      items: [
        {
          title: t('dailyPayHomeScreenTitle'),
          badge: t('dailyPayHomeScreenBadge'),
          description: t('dailyPayHomeScreenDescription'),
          variant: 'dailyPay',
        },
      ],
    },
  }
}
